import { BuilderConfig } from '../../types/Builder';
import BusinessHubHeroEnterPrise, { BusinessHubHeroEnterPriseProps } from './business-hub-hero-enterprise';

export const BusinessHubHeroEnterPriseBuilderConfig = {
    name: 'Business Hub Hero Enterprise',
    inputs: [
        {
            name: 'backgroundColor',
            type: 'color',
            defaultValue: '',
        },
        {
            name: 'backgroundImage',
            type: 'file',
        },
        {
            name: 'backgroundImageMobile',
            type: 'file',
        },
        {
            name: 'content',
            type: 'object',
            subFields: [
                {
                    name: 'image',
                    type: 'file',
                    defaultValue: '',
                },
                {
                    name: 'title',
                    type: 'richText',
                    defaultValue: '',
                },
                {
                    name: 'description',
                    type: 'richText',
                    defaultValue: '',
                },
                {
                    name: 'ctaText',
                    type: 'string',
                },
                {
                    name: 'ctaLink',
                    type: 'string',
                    defaultValue: '',
                },
            ],
        },
    ],
};

const builderConfig: BuilderConfig<BusinessHubHeroEnterPriseProps> = {
    component: BusinessHubHeroEnterPrise,
    config: BusinessHubHeroEnterPriseBuilderConfig,
};

export default builderConfig;
